/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Step_Indicator_PendingInputs */

const tr_geliver_step_indicator_pending = /** @type {(inputs: Geliver_Step_Indicator_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekleniyor`)
};

const en_geliver_step_indicator_pending = /** @type {(inputs: Geliver_Step_Indicator_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const de_geliver_step_indicator_pending = /** @type {(inputs: Geliver_Step_Indicator_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

const ru_geliver_step_indicator_pending = /** @type {(inputs: Geliver_Step_Indicator_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ожидание`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Geliver_Step_Indicator_PendingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_step_indicator_pending = /** @type {((inputs?: Geliver_Step_Indicator_PendingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Step_Indicator_PendingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_step_indicator_pending(inputs)
	if (locale === "de") return de_geliver_step_indicator_pending(inputs)
	if (locale === "ru") return ru_geliver_step_indicator_pending(inputs)
	return tr_geliver_step_indicator_pending(inputs)
});